import React from "react";

const CouponSettings = ({
  couponData,
  formatAmount,
  deleteCoupon,
  handleDeleteCoupon,
  setCouponData,
  newCouponData,
  handleNewCouponChange,
  handleCreateNewCoupon,
}) => {
  return (
    <>
   
    <div className="space-y-6 montserrat-font-1">
      {/* ---------------- COUPON LIST ---------------- */}
      <div className="grid md:grid-cols-3 gap-4 montserrat-font-1">
       {couponData?.length > 0 ? (
  couponData.map((c) => (
          <div
            key={c.id}
            className="bg-white border rounded-xl p-5 shadow-sm"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-3 border-b pb-2">
              <h2 className="text-green-700 font-semibold">
                Coupon Code :{" "}
                <span className="text-gray-800 font-medium">
                  {c.coupon_code}
                </span>
              </h2>

              <div className="flex gap-2">
                <button
                  onClick={async () => {
                    const operation =
                      c.status === "ENABLED" ? "DISABLE" : "ENABLE";

                    const res = await deleteCoupon(c.id, operation);

                    if (res) {
                      setCouponData((prev) =>
                        prev.map((item) =>
                          item.id === c.id
                            ? {
                                ...item,
                                status:
                                  operation === "ENABLE"
                                    ? "ENABLED"
                                    : "DISABLED",
                              }
                            : item
                        )
                      );
                    }
                  }}
                  className="bg-yellow-400 hover:bg-yellow-500 text-sm px-3 py-1 rounded"
                >
                  {c.status === "ENABLED" ? "Disable" : "Enable"}
                </button>

                <button
                onClick={() => {
  const couponId =
    c?.id ||
    c?.couponId ||
    c?.coupon_id ||
    c?.pk_coupon_id;

  handleDeleteCoupon(couponId);
}}
                  className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded"
                >
                  Delete
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Coupon Code:</span>
                <span>{c.coupon_code}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Discount:</span>
                <span>
                  {c.discount_type === "fixed" ? "₹" : ""}
                  {formatAmount(c.discount)}
                  {c.discount_type === "percentage" ? "%" : ""}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Discount Type:</span>
                <span>{c.discount_type}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">
                  Minimum Order Amount:
                </span>
                <span>₹{formatAmount(c.min_amount)}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Title:</span>
                <span>{c.coupon_title}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Description:</span>
                <span>{c.coupon_description}</span>
              </div>
            </div>
          </div>
         ))
) : (
  <div className="md:col-span-3 rounded-xl border bg-white p-6 text-center text-sm text-gray-500">
    No coupons found
  </div>
)}
      </div>

      {/* ---------------- CREATE COUPON ---------------- */}
      <div className="bg-white p-6 rounded-2xl">
        <h2 className="text-green-700 font-semibold text-lg mb-6">
          Create New Coupon
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {/* LEFT */}
          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-700">
                Coupon Code
              </label>
              <input
                name="couponCode"
                value={newCouponData.couponCode}
                onChange={handleNewCouponChange}
                placeholder="Enter Coupon Code"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">
                Min Order Amount
              </label>
              <input
                name="minOrderAmount"
                value={newCouponData.minOrderAmount}
                onChange={handleNewCouponChange}
                placeholder="Enter Min Order Amount"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">
                Coupon Title
              </label>
              <input
                name="couponTitle"
                value={newCouponData.couponTitle}
                onChange={handleNewCouponChange}
                placeholder="Enter Coupon Title"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">
                Discount Type
              </label>
              <select
                name="discountType"
                value={newCouponData.discountType}
                onChange={handleNewCouponChange}
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              >
                <option value="">Select Discount Type</option>
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
          </div>

          {/* RIGHT */}
          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-700">Discount</label>
              <input
                name="discount"
                value={newCouponData.discount}
                onChange={handleNewCouponChange}
                placeholder="Enter Discount"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">
                Maximum Discount Amount
              </label>
              <input
                name="maxDiscountAmount"
                value={newCouponData.maxDiscountAmount}
                onChange={handleNewCouponChange}
                placeholder="Enter Maximum Discount Amount"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>

            <div>
              <label className="text-sm text-gray-700">
                Coupon Description
              </label>
              <input
                name="couponDiscription"
                value={newCouponData.couponDiscription}
                onChange={handleNewCouponChange}
                placeholder="Enter Coupon Description"
                className="w-full mt-1 px-3 py-2 border rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="mt-6">
          <button
            onClick={handleCreateNewCoupon}
            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
          >
            Create Coupon
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default CouponSettings;